export const VAULTS_LABEL = 'Vaults';
export type VaultsLabel = typeof VAULTS_LABEL;
